"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var HomeCheckbox = function (_a) {
    var _b;
    var checked = _a.checked;
    return (react_1.default.createElement("span", { className: classnames_1.default(styles_module_scss_1.default.checkbox, (_b = {}, _b[styles_module_scss_1.default.checkbox_on] = checked, _b)) }, checked && (react_1.default.createElement("svg", { width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "3.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true },
        react_1.default.createElement("path", { d: "M5 12l5 5 9-10" })))));
};
exports.default = HomeCheckbox;
